import { render, staticRenderFns } from "./InspectionRegionalRanking.vue?vue&type=template&id=251e11c6&scoped=true"
import script from "./InspectionRegionalRanking.vue?vue&type=script&lang=js"
export * from "./InspectionRegionalRanking.vue?vue&type=script&lang=js"
import style0 from "./InspectionRegionalRanking.vue?vue&type=style&index=0&id=251e11c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251e11c6",
  null
  
)

export default component.exports